<template>
  <div>
    <div class="dialog-wrap" v-if="visible">
      <div class="mask"></div>
      <div class="dialog">
        <img class="close-img" src="@assets/promotion/close.png" alt="" @click="closeDialog" />
        <div class="dialog-content">预约咨询成功，我们将尽快联系您</div>
        <div class="dialog-btn" @click="closeDialog">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-wrap {
  .mask {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%)
    width: 100%;
    height: 100%;
    z-index 101;
    background: rgba(0, 0, 0, 0.5);
  }
  .dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 500rem;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 20rem;
    z-index: 102;
    padding: 60rem 55rem 50rem;
    text-align: center;
    color: #010101;
    font-size: 30rem;
    .close-img {
      width: 70rem;
      height: 70rem;
      position: absolute;
      right: -30rem;
      top: -30rem;
      cursor: pointer;
    }

    .dialog-btn {
      margin: 45rem auto 0;
      width: 200rem;
      height: 60rem;
      line-height: 60rem;
      text-align: center;
      border: 1px solid #F90080;
      border-radius: 45rem;
      font-size: 26rem;
      color: #fff;
      background: #F90080;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SuccessDialog.vue